/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/schConferences/schConferencesActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";

import { SchConferenceEditForm } from "./SchConferenceEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import { Profile } from "../../profile/Profile";
//import { ScholarProfile } from "../../../../Admin/pages/scholars/scholars-profile/ScholarProfile";
import axios from "axios";

const initSchConference = {
  id: undefined,
  scholarId: 0,
  confTitle: "",
  startDate: "2020-10-16T05:53:31.195Z",
  endDate: "2020-10-16T05:53:31.195Z",
  participated: true,
  presented: true,
  paperName: "",
};
export function SchConferenceEdit({
  history,
  match: {
    params: { id,sid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, schConferenceForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.schConferences.actionsLoading,
      schConferenceForEdit: state.schConferences.schConferenceForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchSchConference(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Scholar Conference";
    if (schConferenceForEdit && id) {
      _title = `Edit Scholar Conference ''`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schConferenceForEdit, id]);

  const saveSchConference = (values) => {
    if (!id) {
      dispatch(actions.createSchConference(values)).then(() =>
        backToSchConferencesList()
      );
    } else {
      dispatch(actions.updateSchConference(values)).then(() =>
        backToSchConferencesList()
      );
    }
  };

  const btnRef = useRef();
  const saveSchConferenceClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const id1 = id===undefined?'':id
  const ScholarUrl = `${process.env.REACT_APP_API_URL}/api/SchConference/${id1}`;

 const [profile, setProfile] = useState([]);
 useEffect(() => {
   const getScholar = async () => {
     const response = await axios.get(`${ScholarUrl}`);
     setProfile(response.data);
   };
   getScholar();
 }, [setProfile, ScholarUrl]);
 const ScholarId = sid?sid:profile.scholarId;
 
 
 
 initSchConference.scholarId=ScholarId;

  const backToSchConferencesList = () => {
    history.push(`/scholar/profile`);
  };

  return (
    <div>
      <Profile />

      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToSchConferencesList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveSchConferenceClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <SchConferenceEditForm
                  actionsLoading={actionsLoading}
                  schConference={schConferenceForEdit || initSchConference}
                  btnRef={btnRef}
                  saveSchConference={saveSchConference}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
